import { render } from "./app.vue?vue&type=template&id=5af5b21c&scoped=true"
const script = {}

import "./app.vue?vue&type=style&index=0&id=5af5b21c&lang=scss&scoped=true"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5af5b21c"]])

export default __exports__